import { normalizeSearch } from '@/lib/text/normalizeSearch';

/**
 * 전화번호로 사람을 찾는다 — <b>하이픈을 신경 쓰지 않고, 뒷자리만 쳐도</b> (사용자 지시 2026-09-23).
 *
 * <h2>왜 따로 두나</h2>
 * 사람이 기억하는 번호는 「1234」·「5678」 같은 조각이고, 대장에 적힌 번호는 「010-1234-5678」
 * 이다. 이름·직급과 같은 {@code includes} 로는 이 둘이 절대 만나지 않는다 — 하이픈 한 칸 때문에
 * 「01012345678」 을 통째로 쳐도 안 걸린다.
 *
 * <p>구분자를 걷는 일은 이미 {@link normalizeSearch} 가 한다(메뉴 검색의 띄어쓰기·가운뎃점).
 * 규칙을 여기서 다시 쓰지 않고 그것을 쓴다 — 두 벌이 되면 한쪽만 고쳐지는 날 같은 말을 쳤는데
 * 화면마다 다른 결과가 나온다.
 *
 * <h2>숫자만 친 검색어에만 걸린다</h2>
 * 「김」 을 친 사람에게 전화번호를 뒤져 줄 이유가 없고, 뒤지면 이름에 없는 사람이 번호 때문에
 * 섞여 나온다. <b>두 자리 이상</b>을 요구하는 것도 같은 이유다 — 한 자리는 거의 모든 번호에 있다.
 */
export function phoneQuery(search: string): string {
  const value = normalizeSearch(search);
  return /^\d{2,}$/.test(value) ? value : '';
}

/**
 * 이 번호가 검색어에 걸리는가.
 *
 * <p>{@code query} 가 빈 문자열이면 <b>언제나 거짓</b>이다 — 숫자 검색이 아닐 때 이 갈래가
 * 참이 되면 필터가 통째로 무력해진다.
 */
export function matchesPhone(phone: string | null | undefined, query: string): boolean {
  if (!query || !phone) return false;
  return normalizeSearch(phone).includes(query);
}
